/** List of available durations for a transition. */
export type TransitionDuration = keyof typeof transitions;

/** A theme object for different transition durations. */
export const transitions = {
  fast: 150,
  medium: 300,
  slow: 600,
};
